import {Component} from 'react';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import {getStipsDocsToResubmitSelector} from '-/selectors';
import NavigationService from '-/services/NavigationService';
import StepButtons from '-/components/general/StepButtons';
import Form from '-/components/fields/Form';
import Button from '-/components/general/Button';

const styles = () => ({
    root: {
        textAlign: 'center',
        '& form': {
            border: '2px solid black'
        }
    },
    bordered: {
        borderBottom: '1px solid black'
    }
});

class StipsResubmit extends Component {
    renderContinueButton() {
        const btn = <Button tag="a" onClick={() => NavigationService.next('stips')}>Continue</Button>;

        return <StepButtons buttons={btn} />;
    }

    render() {
        const {classes = {}} = this.props;

        return (
            <div className="stips-resubmit-dialog">
                <div className={classes.root}>
                    <Form standalone={true}>
                        <p className={`info ${classes.bordered}`}>
                            <strong>Please re-submit the following documents.</strong>
                            <br/>
                            The reasons they could not be verified are listed.
                        </p>
                        <div>
                            {this.props.docsToResubmit.map(doc => {
                                const {
                                    docType,
                                    index,
                                    message
                                } = doc
                                const key = `${docType}_${index}`;
                                return (
                                    <p className="info" key={key}>
                                        <i className="fa fa-warning" style={{color: 'orange'}} />
                                        &nbsp;
                                        <strong>{doc.title}</strong>: <span >{message || 'No message specified.'}</span>
                                    </p>
                                );
                            })}
                        </div>
                    </Form>
                </div>
                {this.renderContinueButton()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        docsToResubmit: getStipsDocsToResubmitSelector(state)
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(StipsResubmit));
